import { createApp } from 'vue'
import { createPinia } from 'pinia'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'

import App from './App.vue'
import router from './router'


const baseSize = 24  // 30 * 80%
function setRem(){
    // 1080 是设计稿宽度
    const scale = document.documentElement.clientWidth / 1080
    //最多放大两倍，可调整
    document.documentElement.style.fontSize = baseSize * Math.min(scale,2) + 'px'
}

//初始化
setRem()
//监听onResize
window.onresize = function(){
    setRem()
}

const app = createApp(App)

app.use(createPinia())
app.use(router)
app.use(ElementPlus)

app.mount('#app')
